import React from "react";
import Modal from "react-bootstrap/Modal";
import PropTypes from "prop-types";

export default function ListingDetailModal({ show, onHide, item }) {
  if (!item) return null;

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>{item.title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <img
          src={item.image}
          alt={item.title}
          style={{ width: "100%", borderRadius: 8, marginBottom: 12 }}
        />
        {item.role && <p className="text-primary mb-1">{item.role}</p>}
        {item.location && (
          <p className="text-muted mb-1">
            <i className="fas fa-map-marker-alt"></i> {item.location}
          </p>
        )}
        {item.followers != null && (
          <p className="text-muted mb-2">👥 {item.followers} Followers</p>
        )}
        {item.description && <p className="mb-0">{item.description}</p>}
      </Modal.Body>
    </Modal>
  );
}

ListingDetailModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  item: PropTypes.shape({
    title: PropTypes.string,
    image: PropTypes.string,
    role: PropTypes.string,
    location: PropTypes.string,
    followers: PropTypes.number,
    description: PropTypes.string,
  }),
};
